import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const Logout = () => {
  const { signOut } = useAuth()
  const navigate = useNavigate()
  const ranRef = useRef(false)

  useEffect(() => {
    let mounted = true
    const run = async () => {
      if (ranRef.current) { console.log('[Logout] already ran, skipping'); return }
      ranRef.current = true
      console.log('[Logout] starting signOut')
      try {
        await signOut()
        console.log('[Logout] signOut finished')
      } catch (e) {
        console.error('[Logout] signOut error', e)
      } finally {
        if (mounted) {
          console.log('[Logout] redirecting to /')
          navigate('/', { replace: true })
        }
      }
    }
    run()
    return () => { mounted = false }
  }, [])

  return (
    <div className="min-h-[30vh] flex items-center justify-center">
      <div className="text-center montserrat text-sm text-gray-500">Signing out...</div>
    </div>
  )
}

export default Logout
